import { render, staticRenderFns } from "./ScAgentDashboard.vue?vue&type=template&id=3d08e0c5&scoped=true&"
import script from "./ScAgentDashboard.vue?vue&type=script&lang=ts&"
export * from "./ScAgentDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./ScAgentDashboard.vue?vue&type=style&index=0&id=3d08e0c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d08e0c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VRow})
